module.exports = __webpack_public_path__ + "static/img/section-shop-banner.f18a911.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/section-shop-banner.jpg
// module id = 461
// module chunks = 1